
import { StoreTypes } from "@/assets/js/Types";
import Vue from "vue";
import { RouterView } from "vue-router";
import homeMenu from "@/components/Home/homeMenu.vue";
export default Vue.extend({
  data() {
    return {
      menus: [] as any[],
      newpath: "" as string,
    };
  },
  mounted() {
    this.getPath();
  },
  components: { RouterView, homeMenu },
  methods: {
    getMenu() {
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
    },
    getPath() {
      const path: string = this.$route.path;
      const array: any[] = path.split("/");
      this.newpath = `/${array[1]}/${array[2]}`;
    },
  },
});
